import React from "react";

const useDateFilter = () => {
  const [selected, setSelected] = React.useState("Single");
  const [startDate, setStartDate] = React.useState(
    new Date().setHours(0, 0, 0, 0)
  );
  const [endDate, setEndDate] = React.useState(
    new Date().setHours(23, 59, 59, 999)
  );

  return {
    selected,
    setSelected,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
  };
};

export { useDateFilter };
